import client from './client';

// Lionjob (chỉ Giám đốc + mã code). Backend: /api/lionjob/... (DB tách riêng).
const BASE = '/lionjob/scraped-product-assignments';

// Mã code lưu tạm trong sessionStorage (mất khi đóng tab -> mở lại phải nhập mã).
export const getCode = () => sessionStorage.getItem('lionjob_code') || '';
export const setCode = (c) => sessionStorage.setItem('lionjob_code', c);
export const clearCode = () => sessionStorage.removeItem('lionjob_code');
// timeout 15s: nếu backend treo (vd server production chưa cấu hình DB matrixty) thì báo lỗi
// thay vì "mở khóa" im lặng mãi không phản hồi.
const hdr = () => ({ headers: { 'x-lionjob-code': getCode() }, timeout: 15000 });
// Riêng gọi Claude (sinh SEO) mất lâu hơn nhiều (Opus 4.8 + thinking + công thức Teeyoung),
// 15s không đủ -> dùng timeout 120s để không bị axios hủy giữa chừng.
const hdrGen = () => ({ headers: { 'x-lionjob-code': getCode() }, timeout: 120000 });

export const listAssignments = (params) => client.get(BASE, { params, ...hdr() }).then((r) => r.data.data);
export const listAccounts = () => client.get('/lionjob/scraped-product-assignments-accounts', hdr()).then((r) => r.data.data);
export const listProducts = (params) => client.get('/lionjob/scraped-products', { params, ...hdr() }).then((r) => r.data.data);
export const getAssignment = (id) => client.get(`${BASE}/${id}`, hdr()).then((r) => r.data.data);
export const updateAssignment = (id, body) => client.patch(`${BASE}/${id}`, body, hdr()).then((r) => r.data.data);
export const markDone = (id) => client.post(`${BASE}/${id}/done`, null, hdr()).then((r) => r.data.data);
export const generateSeo = (id) => client.post(`${BASE}/${id}/generate`, null, hdrGen()).then((r) => r.data.data);
export const createAssignment = (body) => client.post(BASE, body, hdr()).then((r) => r.data.data);

// ---- Màn Trending (đầu phễu: chọn hàng tiềm năng -> đẩy sang Scraped Products) ----
export const listTrending = (params) => client.get('/lionjob/trending', { params, ...hdr() }).then((r) => r.data.data);
export const trendingCounts = () => client.get('/lionjob/trending/counts', hdr()).then((r) => r.data.data);
export const pushTrending = (ids, force) => client.post('/lionjob/trending/push', { ids, force }, hdr()).then((r) => r.data);
export const skipTrending = (ids) => client.post('/lionjob/trending/skip', { ids }, hdr()).then((r) => r.data);

// ---- Màn Ideas (giữa phễu: kiểm bản quyền + chấm thiết kế) ----
export const listIdeas = (params) => client.get('/lionjob/ideas', { params, ...hdr() }).then((r) => r.data.data);
export const ideasCounts = () => client.get('/lionjob/ideas/counts', hdr()).then((r) => r.data.data);
export const pushIdeas = (ids, force) => client.post('/lionjob/ideas/push', { ids, force }, hdr()).then((r) => r.data);
export const skipIdeas = (ids) => client.post('/lionjob/ideas/skip', { ids }, hdr()).then((r) => r.data);

// ---- Kho mockup (ảnh nhặt từ web, đã tải về server) ----
export const listMockups = (params) => client.get('/lionjob/mockups', { params, ...hdr() }).then((r) => r.data.data);
export const updateMockup = (id, body) => client.patch(`/lionjob/mockups/${id}`, body, hdr()).then((r) => r.data.data);
export const removeMockup = (id) => client.delete(`/lionjob/mockups/${id}`, hdr()).then((r) => r.data);

// ---- Sức khoẻ shop Etsy ----
export const listShopIndex = (params) => client.get('/lionjob/shop-index', { params, ...hdr() }).then((r) => r.data.data);
export const shopHistory = (shop) => client.get(`/lionjob/shop-index/${encodeURIComponent(shop)}/history`, hdr()).then((r) => r.data.data);

// ---- MCP Ytrends (backend nối thẳng tới MCP server) ----
// Kết nối + kéo dữ liệu có thể lâu -> dùng timeout dài như gọi Claude.
export const ytStatus = () => client.get('/lionjob/ytrends/status', hdrGen()).then((r) => r.data.data);
export const ytCall = (tool, args) => client.post('/lionjob/ytrends/call', { tool, args }, hdrGen()).then((r) => r.data.data);
export const ytSync = (body) => client.post('/lionjob/ytrends/sync', body || {}, hdrGen()).then((r) => r.data);
export const ytSnapshot = (day) => client.get('/lionjob/ytrends/snapshot', { params: day ? { day } : {}, ...hdrGen() }).then((r) => r.data.data);

// ---- Mã vận đơn (nhập danh sách -> extension điền lên sàn) ----
export const listTracking = (params) => client.get('/lionjob/tracking', { params, ...hdr() }).then((r) => r.data.data);
export const importTracking = (body) => client.post('/lionjob/tracking/import', body, hdr()).then((r) => r.data);
export const removeTracking = (id) => client.delete(`/lionjob/tracking/${id}`, hdr()).then((r) => r.data);
